import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import {hashHistory} from "react-router";

import {setCameFromPage, toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import {canShowSqftButtonForFeature, canShowSqftCabinetButtonForFeature} from "../../../misc/helpers";
import {toggleGalleryVisible} from "../../../actions/selectionFunctions";
import Analytics from './../../../analytics';
import RowItemQuantity from "./rowItemQuantity";
import RowItemPrice from "./rowItemPrice";
import {enableSquareFootage, setSqftFromFeature, setSquareFootageGroup} from "../../../actions/sqftFunctions";
import {SQFT_GROUP} from "../../sqft/constants";
import store from "../../../store";
import {setWizardConflictPopupOpened} from "../../../actions/wizardFunctions";

const RowItemButtons = (props) => {

  const {currentFeature, fabricatorData, goToFeatureInfo, toggleGalleryVisible, setCameFromPage, showAdvancedQuoting,
    isRelated, setSqftFromFeature, infoButtonVisible, showPrice, enableSquareFootage, setSquareFootageGroup,
    setWizardConflictPopupOpened, isModalFixOpen} = props;
  const fabricatorSettings = fabricatorData.settings;

  const showGalleryButton = currentFeature && !isRelated && currentFeature.dbFeature.galleryImages && currentFeature.dbFeature.galleryImages.length;

  const canShowSqft = canShowSqftButtonForFeature(currentFeature, fabricatorSettings) && !isRelated;
  const canShowCabinetsSqft = canShowSqftCabinetButtonForFeature(currentFeature, fabricatorSettings) && !isRelated;

  const openSqft = () => {
    setCameFromPage("materials");
    setSqftFromFeature({cartFeature: currentFeature});
    enableSquareFootage(true);
    if (canShowCabinetsSqft) {
      setSquareFootageGroup(SQFT_GROUP.cabinets);
      hashHistory.push("sqft?group=cabinets");
    } else {
      setSquareFootageGroup(SQFT_GROUP.default);
      hashHistory.push("sqft");
    }
  }

  const handleSQFTButtonClick = () => {
    Analytics.sendClickEvent("sqft-opened");
    const {wizardConflictingSteps} = store.getState().wizardState;
    if (wizardConflictingSteps?.length) {
      setWizardConflictPopupOpened(true, openSqft);
      return
    }
    openSqft();
  };

  const handleGalleryButtonClick = () => {
    Analytics.sendClickEvent("gallery-opened");
    toggleGalleryVisible(true, currentFeature);
  };

  return (
    <div className="m-bottom__right">
      {showGalleryButton
        ? <button className="m-button m-button--image" onClick={handleGalleryButtonClick}/>
        : null}
      {!isModalFixOpen && (canShowSqft || canShowCabinetsSqft) ? (
        <button className="m-button m-button--sqft" onClick={handleSQFTButtonClick}/>
      ) : null}
      {isModalFixOpen || isRelated || !infoButtonVisible ? null : <span className="m-button m-button--info" onClick={goToFeatureInfo}/>}
      <div className="m-quantity">
        {showPrice ? <RowItemPrice currentFeature={currentFeature}/> : null}
        {!isModalFixOpen && !showAdvancedQuoting ? <RowItemQuantity currentFeature={currentFeature}/> : null}
      </div>
    </div>
  )
};

RowItemButtons.propTypes = {
  currentFeature: PropTypes.object.isRequired,
  goToFeatureInfo: PropTypes.func.isRequired,
  isRelated: PropTypes.bool,
  infoButtonVisible: PropTypes.bool,
  showPrice: PropTypes.bool,
};

const mapStateToProps = (store) => {
  const {showAdvancedQuoting} = store.advancedQuotingState;
  return {
    fabricatorData: store.fabricatorState,
    showAdvancedQuoting,
    isModalFixOpen: store.sqftModalFixState.isModalFixOpen,
  };
};

const mapDispatchToProps = {
  toggleSelectionFeatureInfo,
  setCameFromPage,
  toggleGalleryVisible,
  setSqftFromFeature,
  enableSquareFootage,
  setSquareFootageGroup,
  setWizardConflictPopupOpened,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RowItemButtons)
)
